import http from 'hub-http/clients/apiClient';
import { stringify } from 'hub-http/helpers/params';
import { getFullUrl } from 'hubspot-url-utils';
export const fetchDataModelRecommendedHub = (earlyRequester, hubTypes) => {
  let params;
  if (hubTypes && hubTypes.length) {
    params = stringify({
      hubType: hubTypes
    });
  }
  const url = `${getFullUrl('app-api', {})}/personalization/v1/recommendation/ml${params ? `?${params}` : ''}`;
  if (earlyRequester) {
    const earlyRequest = earlyRequester('recommended-hub', () => http.get(url));
    return earlyRequest && earlyRequest.catch(() => {
      return http.get(url);
    });
  } else {
    return http.get(url);
  }
};